function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce, useSearchParam } from 'react-use';
import Control from '../../components/form/Control';
import { listProjectActivities } from '../../redux/actions/activity';
import text from '../../text';
import { AUTOSEARCH_DELAY } from '../constants';
var SearchActivitiesInput = function(param) {
    var projectId = param.projectId;
    var dispatch = useDispatch();
    var _useState = _sliced_to_array(useState(), 2), queryValue = _useState[0], setQueryValue = _useState[1];
    var projects = useSelector(function(state) {
        return {
            projects: state.activity.projects
        };
    }).projects;
    var queryParam = useSearchParam('query');
    var _useDebounce = _sliced_to_array(useDebounce(function() {
        var _projects_projectId_ui, _projects_projectId;
        return projectId && !((_projects_projectId = projects[projectId]) === null || _projects_projectId === void 0 ? void 0 : (_projects_projectId_ui = _projects_projectId.ui) === null || _projects_projectId_ui === void 0 ? void 0 : _projects_projectId_ui.isLoading) && dispatch(listProjectActivities(projectId, queryValue));
    }, AUTOSEARCH_DELAY, [
        queryValue
    ]), 1), isReady = _useDebounce[0];
    useEffect(function() {
        if (queryParam && queryParam !== queryValue) {
            setQueryValue(queryParam);
        }
    }, [
        queryParam
    ]);
    useEffect(function() {
        if (queryValue && projectId) {
            isReady();
        }
    }, [
        queryValue
    ]);
    return /*#__PURE__*/ React.createElement(Control, {
        as: "input",
        type: "text",
        name: "search",
        value: queryValue,
        onChange: function(event) {
            return setQueryValue(event.target.value);
        },
        iconProps: {
            icon: 'search'
        },
        placeholder: text('searchHere'),
        autoComplete: "off"
    });
};
export default SearchActivitiesInput;
